import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

const header = css`
  height: 50px;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-radius: 6px 6px 0px 6px;

  & > *:last-child {
    margin-left: auto;
  }
`;

const headerDescription = (isEventMedia: boolean) => css`
  display: flex;
  align-items: center;
  font-weight: ${fonts.weight.medium};
  font-size: ${fonts.size.medium};

  & > *:is(:first-child) {
    color: ${colors.gray.dark};
    margin-right: 12px;
  }

  & > *:is(:last-child) {
    margin-left: ${isEventMedia ? '20' : '0'}px;
  }
`;

export default {
  header,
  headerDescription,
};
